export enum Action {
  CREATE,
  UPDATE,
  DELETE,
}

export const ACTIONS = [
  { value: Action.CREATE, label_en: 'Create', label_fr: 'Création' },
  { value: Action.UPDATE, label_en: 'Update', label_fr: 'Modification' },
  { value: Action.DELETE, label_en: 'Delete', label_fr: 'Suppression' },
]
